import { type ErrorComponentProps, Link } from '@tanstack/react-router'
import { AxiosError } from 'axios'
import { AlertCircle, ArrowLeft } from 'lucide-react'

interface ErrorDisplay {
  message: string
  title: string
}

type ReservationErrorProps = ErrorComponentProps | { error?: Error | null }

export function ReservationError(props: ReservationErrorProps) {
  const { message, title } = getErrorDisplay(props.error)

  return (
    <div className="flex flex-1 items-center justify-center">
      <div className="flex max-w-md flex-col items-center gap-6 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
          <AlertCircle className="h-8 w-8 text-red-600" />
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-semibold text-stone-800">{title}</h1>
          <p className="text-stone-600">{message}</p>
        </div>

        <Link
          to="/research-bar"
          className="inline-flex items-center gap-2 rounded-lg bg-[#1D95AD] px-6 py-3 font-medium text-white transition-colors hover:bg-[#1a8599]"
        >
          <ArrowLeft className="h-4 w-4" />
          Retour à la recherche
        </Link>
      </div>
    </div>
  )
}

function getErrorDisplay(error: Error | null | undefined): ErrorDisplay {
  if (error instanceof AxiosError) {
    const backendMessage = error.response?.data?.message
    if (typeof backendMessage === 'string') {
      return {
        message: backendMessage,
        title: 'Erreur',
      }
    }
  }

  return {
    message: "Le devis que vous recherchez n'existe pas ou n'est plus disponible.",
    title: 'Devis introuvable',
  }
}
